<template>
    <section>
        <h1 class="mb-0 mt-5 mb-3 text-center">{{$t('students.header')}}</h1>

        <v-row>
            <v-col cols="10">
                <v-text-field
                        v-model="keyword"
                        :label="$t('global.search')"
                        hide-details
                >
                    <template v-slot:prepend-inner>
                        <svg v-svg="'icon-search'" size="15"></svg>
                    </template>
                </v-text-field>
            </v-col>

            <v-col cols="2">
                <v-select :items="[{team_name: $t('global.all'), team_id: 0}, ...STUDENTS]"
                          :label="$t('students.team')"
                          item-text="team_name"
                          item-value="team_id"
                          v-model="team_id"
                          @change="getData()"
                >
                    <template v-slot:append>
                        <svg v-svg="'icon-select'" size="16"></svg>
                    </template>
                </v-select>
            </v-col>
        </v-row>

        <v-data-table :headers="headers"
                      :items="STUDENTS"
                      hide-default-footer
                      class="elevation-1 mt-13 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.avatar="props">
                <v-avatar size="38">
                    <img :src="props.item.avatar || require('@/../public/images/Avatar.png')">
                </v-avatar>
            </template>

            <template v-slot:item.id="props">
                {{props.index+1}}
            </template>

            <template v-slot:item.actions="props">
                <v-btn text class="px-0 mr-3" :to="{name: 'DoneQuizzes', query: {student_id: props.item.id}}">
                    <svg v-svg="'icon-quiz'" size="12" class="mr-1"></svg>
                    <span class="orange-text">{{$t('quizzes.header')}}</span>
                </v-btn>

                <v-btn text class="px-0" :to="{name: 'DoneHomework', query: {student_id: props.item.id}}">
                    <svg v-svg="'icon-done'" size="12" class="mr-1"></svg>
                    <span class="green-text">{{$t('students.done_homework')}}</span>
                </v-btn>
            </template>

            <template v-slot:header.actions class="d-none"></template>
        </v-data-table>
        <div class="float-end mb-5">
            <v-pagination  v-model="STUDENTS_PAGINATOR.current"
                           :length="STUDENTS_PAGINATOR.total"
                           :total-visible="3"
                           color="green"
                           @input="getData"
            ></v-pagination>
        </div>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        data(){
            return {
                timeout: null,
                loadingRequest: false,
                team_id: this.$route.query.team_id || null,
                keyword: null,
                headers: [
                    {text: 'Avatar', sortable: false, value: 'avatar', align: 'center'},
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: this.$t('students.full_name'), sortable: false, value: 'full_name'},
                    {text: this.$t('students.email'), sortable: false, value: 'email'},
                    {text: this.$t('students.phone'), sortable: false, value: 'phone'},
                    {text: this.$t('students.team'), sortable: false, value: 'team_name'},
                    {text: 'Actions', sortable: false, value: 'actions', align: 'right'}
                ],
            }
        },

        computed: mapGetters(['STUDENTS','STUDENTS_PAGINATOR']),

        watch: {
            keyword() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.getData();
                }, 300);
            }
        },

        mounted(){
            this.getData();
        },

        methods: {
            getData(page = 0){
                this.loadingRequest = true;
                this.$store.dispatch('GET_STUDENTS', {
                    params: { page, team_id: this.team_id, keyword: this.keyword}
                })
                    .then(() => this.loadingRequest = false);
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/pages/tablePages";
    @import "../../scss/pages/Users/Students/students";
</style>